<div class="employee-basket-benefit-row">
  <div class="employee-basket-benefit-row__info">
    <span class="employee-basket-benefit-row__name">
      @if (benefit().isFromClosedPeriod) {
        <mat-icon
          class="employee-basket-benefit-row__closed-period-icon fo-color-error"
          svgIcon="fo-calendar-pending"
          [matTooltip]="'employee.previous-year-cart-benefit-tooltip' | translate"
        ></mat-icon>
      }
      {{ benefit().name | translate }}
    </span>
    <flexyoo-employee-financing-plan-badge
      [pbGrossAmount]="pbGrossAmount()"
      [ssGrossAmount]="ssGrossAmount()"
    />
  </div>
  <div class="employee-basket-benefit-row__amount">
    <div class="employee-basket-benefit-row__amount-line">
      {{ benefit().yearlyGrossPrice | flexyooNumber }}
    </div>
  </div>
  @if (showNetSavingCell()) {
    <div
      class="employee-basket-benefit-row__net-saving"
      [class.employee-basket-benefit-row__net-saving--actions-only]="!showNetSavingColumn()"
      [class.employee-basket-benefit-row__net-saving--confirm-disabled]="
        showConfirmIcon() && isConfirmDisabled()
      "
      [style.color]="wls.warnColor"
    >
      @if (showNetSavingAmount()) {
        {{ benefit().netGainAmount | flexyooNumber }}
      }
      @if (showConfirmIcon() && !isConfirmDisabled()) {
        <span
          class="employee-basket-benefit-row__confirm"
          [matTooltip]="'employee.basket.confirm-order-tooltip' | translate"
        >
          <mat-icon svgIcon="fo-checkbook"></mat-icon>
        </span>
      }
      @if (showRemoveButton() && benefit().canRemove) {
        <button
          class="employee-basket-benefit-row__remove"
          type="button"
          (click)="onRemoveClick($event)"
        >
          <mat-icon svgIcon="fo-trash"></mat-icon>
        </button>
      }
    </div>
  }
</div>
